import { Icon, type IconProps } from '@ironhack/design-system2/components/icon';
import { ArrowRight } from '@ironhack/design-system2/icons/arrow-right';
import { ChevronDown } from '@ironhack/design-system2/icons/chevron-down';
import { ChevronRight } from '@ironhack/design-system2/icons/chevron-right';
import { type ReactElement } from 'react';

type Props = {
  itemType: 'link' | 'menu';
  iconDirection?: 'down' | 'right';
} & IconProps;

export const NavItemIcon = (props: Props): ReactElement => {
  const {
    boxSize = '20px',
    iconDirection = 'right',
    itemType,
    ...iconProps
  } = props;

  const isLink = itemType === 'link';
  const Chevron = iconDirection === 'down' ? ChevronDown : ChevronRight;

  return (
    <Icon as={isLink ? ArrowRight : Chevron} boxSize={boxSize} {...iconProps} />
  );
};
